<template>
  <div
    class="collapsible"
    :class="{ 'collapsible--active': isActive }"
  >
    <div
      class="collapsible__title"
      :class="{ 'flex items-center justify-between': !isDisabled }"
      @click="toggle()"
    >
      <div><slot name="title" /></div>
      <div
        v-if="!isDisabled"
        class="collapsible__toggle"
        :class="{ 'collapsible__toggle--active': isActive, 'lg:hidden': isDesktopDisabled }"
      >
        <span
          v-if="!useArrowIcons"
          class="icon-plus"
          :class="{
            'block': !isActive,
            'hidden': isActive
          }"
        />
        <span
          v-else
          class="icon-dropdown-arrow"
          :class="{
            'block': !isActive,
            'hidden': isActive
          }"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M11.6023 8.33708C11.822 8.11741 12.1781 8.11741 12.3978 8.33708L18.1326 14.072C18.3523 14.2916 18.3523 14.6477 18.1326 14.8674L17.8674 15.1326C17.6478 15.3523 17.2916 15.3523 17.0719 15.1326L12 10.0607L6.92808 15.1326C6.7084 15.3523 6.3523 15.3523 6.13263 15.1326L5.86743 14.8674C5.64775 14.6477 5.64775 14.2916 5.86743 14.072L11.6023 8.33708Z"
              fill="#fff"
            />
          </svg>
        </span>
        <span
          v-if="!useArrowIcons"
          class="icon-minus"
          :class="{
            'hidden': !isActive,
            'block': isActive
          }"
        />
        <span
          v-else
          class="icon-dropdown-arrow"
          :class="{
            'hidden': !isActive,
            'block': isActive
          }"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M11.6023 8.33708C11.822 8.11741 12.1781 8.11741 12.3978 8.33708L18.1326 14.072C18.3523 14.2916 18.3523 14.6477 18.1326 14.8674L17.8674 15.1326C17.6478 15.3523 17.2916 15.3523 17.0719 15.1326L12 10.0607L6.92808 15.1326C6.7084 15.3523 6.3523 15.3523 6.13263 15.1326L5.86743 14.8674C5.64775 14.6477 5.64775 14.2916 5.86743 14.072L11.6023 8.33708Z"
              fill="#fff"
            />
          </svg>
        </span>
      </div>
    </div>
    <collapse-transition>
      <div
        v-show="isActive"
        :class="{ 'lg:block': isDesktopDisabled }"
      >
        <div class="collapsible__content">
          <slot />
        </div>
      </div>
    </collapse-transition>
  </div>
</template>

<script>
/*
* Collapsible Vue component
* ---
* Example usage:
*
* <vue-collapsible>
*   <template v-slot:title>Accordion Title</template>
*   <template>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</template>
* </vue-collapsible>
*/

import { CollapseTransition } from 'vue2-transitions'

export default {
  components: {
    CollapseTransition
  },

  props: {
    isOpen: {
      type: Boolean,
      default: false
    },

    isDisabled: {
      type: Boolean,
      default: false
    },

    isDesktopDisabled: {
      type: Boolean,
      default: false
    },

    useArrowIcons: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      isActive: this.isOpen
    }
  },

  created () {
    if (this.isDisabled) {
      this.isActive = true
    }
  },

  methods: {
    toggle () {
      if (this.isDisabled) return
      this.isActive = !this.isActive
    },

    close () {
      if (this.isDisabled) return
      this.isActive = false
    },

    open () {
      if (this.isDisabled) return
      this.isActive = true
    }
  }
}
</script>
